// ----------------------------------------------------------------------------
// Section: Product Slider
// ----------------------------------------------------------------------------
//
// This is a section that displays product slider items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_product-slider.scss';

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------

function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--product-slider").each(function(index, element){
    var $this = $(this);

    // Generate unique class for each feature collection slider
    $this.addClass("product-slider-instance-" + index);

    // Initialize feature collection slider based on the unique classes generated above.
    var swiper = new Swiper(".product-slider-instance-" + index, {
        // Optional parameters
        modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
        slidesPerView: 1.4,
        spaceBetween: 5,
        centerInsufficientSlides: true,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
        grabCursor: true,

        breakpoints: {
            680: {
                slidesPerView: 2.5,
                spaceBetween: 50,
            },
            1024: {
                slidesPerView: 3.6,
                spaceBetween: 72,
            },
            1920: {
                slidesPerView: 3.7,
                spaceBetween: 72,
            }
        }
    });

    swiper.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiper.slideTo(index);
        })
    });
  });
});
